<template>
    <div class="signin-form">
        <div v-if="!showVerify && !signinOnly" class="vehica-login-register-tabs-wrapper">
            <div class="vehica-login-register-tabs">
                <button @click="setTab(REGISTER)"
                        class="vehica-login-register-tabs__register"
                        :class="{'vehica-active': currentTab === REGISTER}">
                    Register
                </button>

                <button @click="setTab(SIGNIN)"
                        class="vehica-login-register-tabs__login"
                        :class="{'vehica-active': [SIGNIN, FORGOT, CODE].includes(currentTab)}">
                    Sign in
                </button>
            </div>
        </div>

        <div v-if="!showVerify" class="vehica-panel-login-register">
            <div class="vehica-login"
                 :class="{'vehica-active': currentTab === SIGNIN, 'bg-white': signinOnly }">
                <div class="vehica-login__inner">
                    <h3>Welcome back! Sign in to your account.</h3>

                    <form @submit.prevent="onLogin">
                        <div v-if="message"
                             class="vehica-register-login-notice">
                            {{ message }}
                        </div>

                        <!--@* <partial name="SocialSignIn.cshtml" /> *@-->

                        <div class="vehica-fields">
                            <div class="vehica-field"
                                 :class="{'vehica-field--validation-required': errors.login}">
                                <input id="login"
                                       name="login"
                                       placeholder="Email"
                                       @input="setLogin($event.target.value)"
                                       type="text">

                                <div v-if="showErrors" class="vehica-field--validation-required__tip">
                                    <div v-if="errors.login"
                                         class="vehica-field--validation-required__tip__text">
                                        {{ errors.login }}
                                    </div>
                                </div>
                            </div>

                            <div class="vehica-field"
                                 :class="{'vehica-field--validation-required': errors.password}">
                                <input id="vehica-login-password"
                                       name="password"
                                       @input="setPassword($event.target.value)"
                                       placeholder="Password"
                                       type="password">

                                <div v-if="showErrors" class="vehica-field--validation-required__tip">
                                    <div v-if="errors.password"
                                         class="vehica-field--validation-required__tip__text">
                                        {{ errors.password }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="vehica-login__below-fields">
                            <div class="vehica-login__remember">
                                <div class="vehica-checkbox">
                                    <input @change.prevent="setRemember"
                                           id="remember"
                                           name="remember"
                                           type="checkbox"
                                           :checked="remember">

                                    <label for="remember">
                                        Remember
                                    </label>
                                </div>
                            </div>

                            <div class="vehica-login__forgotten-password">
                                <a href="" @click.prevent="setTab(FORGOT)">
                                    Forgotten password?
                                </a>
                            </div>
                        </div>

                        <submit-button class-name="vehica-button--login" :active="loading">Sign in</submit-button>
                    </form>
                </div>
            </div>

            <div class="vehica-register" :class="{'vehica-active': currentTab === REGISTER}">
                <div class="vehica-register__inner">
                    <div class="d-inline-flex">
                        <ul class="list-unstyled mt-3 text-start">
                            <li><i class="fa fa-fw fa-unlock me-2"></i>Unlock a personalized experience</li>
                            <li><i class="fa fa-fw fa-car me-2"></i>Access to car valuation tools</li>
                            <li><i class="fa fa-fw fa-ellipsis-h me-2"></i>Plus many more</li>
                        </ul>
                    </div>

                    <form @submit.prevent="onRegister">
                        <div v-if="message">
                            {{ message }}
                        </div>

                        <!--@* <partial name="SocialSignIn.cshtml" />  *@-->

                        <div v-if="showErrors">
                            <div v-if="errors.termsAccept" class="vehica-register-login-notice">
                                You must accept the privacy policy
                            </div>
                        </div>

                        <div class="vehica-fields">
                            <div class="vehica-field"
                                 :class="{'vehica-field--validation-required': errors.name}">
                                <input id="name"
                                       name="name"
                                       v-model="name"
                                       type="text"
                                       placeholder="Name *"
                                       required>

                                <div v-if="showErrors"
                                     class="vehica-field--validation-required__tip">
                                    <div v-if="errors.name"
                                         class="vehica-field--validation-required__tip__text">
                                        {{ errors.name }}
                                    </div>
                                </div>
                            </div>

                            <div class="vehica-field"
                                 :class="{'vehica-field--validation-required': errors.email}">
                                <input id="email"
                                       name="email"
                                       v-model="email"
                                       type="text"
                                       placeholder="Email *"
                                       required>

                                <div v-if="showErrors"
                                     class="vehica-field--validation-required__tip">
                                    <div v-if="errors.email"
                                         class="vehica-field--validation-required__tip__text">
                                        {{ errors.email }}
                                    </div>
                                </div>
                            </div>

                            <div class="vehica-field"
                                 :class="{'vehica-field--validation-required': errors.phone}">
                                <input id="phone"
                                       name="phone"
                                       v-model="phone"
                                       type="text"
                                       placeholder="Phone">

                                <div v-if="showErrors"
                                     class="vehica-field--validation-required__tip">
                                    <div v-if="errors.phone"
                                         class="vehica-field--validation-required__tip__text">
                                        {{ errors.phone }}
                                    </div>

                                </div>
                            </div>

                            <div class="vehica-field"
                                 :class="{'vehica-field--validation-required': errors.password}">
                                <input id="vehica-register-password"
                                       name="password"
                                       @input="setPassword($event.target.value)"
                                       type="password"
                                       placeholder="Password *"
                                       required>

                                <div v-if="showErrors"
                                     class="vehica-field--validation-required__tip">
                                    <div v-if="errors.password"
                                         class="vehica-field--validation-required__tip__text">
                                        {{ errors.password }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="vehica-register__terms">
                            <div class="vehica-checkbox">
                                <input :checked="termsAccept"
                                       @change.prevent="setTermsAccept"
                                       type="checkbox"
                                       id="checkbox_terms">

                                <label for="checkbox_terms">
                                    I agree to the terms of the <a href="/privacy-policy">privacy policy</a>
                                </label>
                            </div>
                        </div>

                        <submit-button class-name="vehica-button--register" :active="loading">Register</submit-button>
                    </form>
                </div>
            </div>

            <div class="vehica-login"
                 :class="{'vehica-active': currentTab === FORGOT, 'bg-white': signinOnly }">
                <div class="vehica-login__inner">
                    <h3>Forgot your password? No problem! We'll send you a one-time sign in code. Just enter your registered email to continue.</h3>

                    <form @submit.prevent="onForgotPassword">
                        <div v-if="message"
                             class="vehica-register-login-notice">
                            {{ message }}
                        </div>

                        <div class="vehica-fields">
                            <div class="vehica-field"
                                 :class="{'vehica-field--validation-required': errors.login}">
                                <input id="login"
                                       name="login"
                                       placeholder="Email"
                                       @input="setLogin($event.target.value)"
                                       type="text">

                                <div v-if="showErrors" class="vehica-field--validation-required__tip">
                                    <div v-if="errors.login"
                                         class="vehica-field--validation-required__tip__text">
                                        {{ errors.login }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <submit-button class-name="vehica-button--register" :active="loading">Send Code</submit-button>
                    </form>
                </div>
            </div>
        </div>

        <div class="vehica-login"
             :class="{'vehica-active': currentTab === CODE, 'bg-white': signinOnly }">
            <div class="vehica-login__inner">
                <h3>Forgot your password? No problem! Enter your one-time sign in code to continue.</h3>

                <form @submit.prevent="onForgotPasswordCode">
                    <div v-if="message"
                         class="vehica-register-login-notice">
                        {{ message }}
                    </div>

                    <div class="vehica-fields">
                        <div class="vehica-field"
                             :class="{'vehica-field--validation-required': errors.login}">
                            <input id="code"
                                   name="code"
                                   placeholder="123456"
                                   @input="setKey($event.target.value)"
                                   type="text">

                            <div v-if="showErrors" class="vehica-field--validation-required__tip">
                                <div v-if="errors.code"
                                     class="vehica-field--validation-required__tip__text">
                                    {{ errors.code }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <submit-button class-name="vehica-button--register" :active="loading">Sign in</submit-button>
                </form>
            </div>
        </div>

        <div v-if="showVerify" class="vehica-panel-login-register">
            <div class="vehica-login vehica-active">
                <div class="vehica-login__inner">
                    <div class="vehica-register-login-notice vehica-register-login-notice--resend-email mt-5">
                        <div>
                            Your account is not confirmed yet.
                        </div>

                        <div>
                            Please check your email for instructions to confirm your account.
                        </div>

                        <div v-if="message" class="vehica-register-login-notice mt-4">
                            {{ message }}
                        </div>

                        <a href="" @click.prevent="sendConfirmation">
                            <i class="fas fa-envelope"></i> Resend confirmation email
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import axios from 'axios';
    import SubmitButton from '../../common/fields/SubmitButton';

    const CODE = 'code';
    const FORGOT = 'forgotpassword';
    const REGISTER = 'register';
    const SIGNIN = 'signin';

    export default {
        props: ['autoReload', 'defaultTab', 'signinOnly'],
        emits: ['success'],
        components: {
            SubmitButton
        },
        data: function () {
            return {
                CODE,
                FORGOT,
                REGISTER,
                SIGNIN,
                currentTab: REGISTER,
                email: '',
                errors: {},
                key: '',
                loading: false,
                login: '',
                message: '',
                name: '',
                password: '',
                phone: '',
                confirmationId: '',
                remember: true,
                showErrors: false,
                showVerify: false,
                termsAccept: false,
            };
        },
        created() {
            if (this.signinOnly || this.defaultTab === SIGNIN) {
                this.setTab(SIGNIN);
            }
        },
        methods: {
            onForgotPassword() {
                let data = {
                    login: this.login,
                    //recaptchatoken: '',
                };
                this.submitForm('/account/forgotpassword', data);
            },
            onForgotPasswordCode() {
                let data = {
                    id: this.confirmationId,
                    key: this.key,
                    //recaptchatoken: '',
                };
                this.submitForm('/account/onetimesignin', data);
            },
            onLogin() {
                let data = {
                    login: this.login,
                    phone: this.phone,
                    password: this.password,
                    //recaptchatoken: '',
                    //returnurl: null,
                    //forgotpasswordsent: null,
                    remember: this.remember,
                };
                this.submitForm('/account/signin', data);
            },
            onRegister() {
                let data = {
                    email: this.email,
                    name: this.name,
                    phone: this.phone,
                    password: this.password,
                    //recaptchatoken: '',
                    //returnurl: null,
                    termsAccept: this.termsAccept,
                };
                this.submitForm('/account/register', data);
            },
            sendConfirmation() {
                const vm = this;
                let data = {
                    id: vm.confirmationId
                };
                axios.post('/account/sendconfirmation', data)
                    .then(r => {
                        vm.showErrors = false;
                        vm.message = r.data.message;
                    })
                    .catch(e => {
                        vm.showErrors = true;
                        vm.message = e.data?.message || e.message || 'Something went wrong. Try again later.';
                    });
            },
            setKey(value){
                this.key = value?.trim();
            },
            setLogin(value) {
                this.login = value?.trim();
            },
            setPassword(value) {
                this.password = value?.trim();
            },
            setRemember(value) {
                this.remember = !this.remember;
            },
            setTab(tab) {
                this.message = '';
                this.errors = {};
                this.showErrors = false;
                this.currentTab = tab;
            },
            setTermsAccept(value) {
                this.termsAccept = !this.termsAccept;
            },
            submitForm(url, data) {
                const vm = this;
                vm.showErrors = false;
                vm.loading = true;
                data.nonce = new Date().getTime().toString(16);

                axios.post(url, data)
                    .then(r => {
                        if (r.data.success) {
                            if (r.data.verify) {
                                vm.message = '';
                                vm.errors = {};
                                vm.showErrors = false;
                                vm.showVerify = true;
                                vm.confirmationId = r.data.id;
                            } else if (r.data.code) {
                                vm.setTab(CODE);
                                vm.message = r.data.message;
                                vm.errors = {};
                                vm.showErrors = false;
                                vm.showVerify = false;
                                vm.confirmationId = r.data.id;
                            } else if (r.data.signin) {
                                vm.setTab(SIGNIN);
                                vm.message = r.data.message;
                            } else if (vm.autoReload) {
                                window.location.reload();
                            } else {
                                vm.$emit('success');
                            }
                        } else {
                            vm.showErrors = true;
                            vm.message = r.data.message;
                            vm.errors = r.data.errors || {};
                        }
                    })
                    .catch(e => {
                        vm.showErrors = true;
                        vm.message = e.data?.message || e.message || 'Something went wrong. Try again later.';
                    })
                    .finally(() => {
                        vm.loading = false;
                    });
            }
        }
    }
</script>